//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ABCD",
  data() {
    return {
      defaultJson: {
        "Same-sided ≥50% ICA stenosis": "同侧颈内动脉狭窄 ≥ 50%",
        "Hyperintensity on Diffusion MRI": "MRI 弥散序列呈现高信号",
        "just occurred": "小于 10 分钟",
        "Clinical Features": "临床表现",
        "intermediate stroke risk": "即刻脑卒中风险",
        Diabetes: "糖尿病",
        "Speech disturbance, no weakness": "言语障碍，不伴肌无力",
        Hypertension: "高血压",
        "Age > 60 years": "年龄 > 60 岁",
        "low risk for stroke": "脑卒中低危",
        "10 - 59 minutes (short)": "10 - 59 分钟",
        ">= 60 minutes (short)": "≥ 60 分钟",
        "10 - 59 minutes": "10 - 59 分钟",
        ">= 60 minutes": "60 分钟或更久",
        "Dual TIA (2nd within 7 days)": "再发 TIA（7 天内第 2 次发作）",
        "Unilateral weakness": "单侧肌无力",
        "No weakness": "无肌无力",
        "just occurred (short)": "< 10 分钟",
        "Unilateral weakness (short)": "单侧",
        "Speech disturbance, no weakness (short)": "仅言语障碍",
        "high risk for stroke": "脑卒中高危",
        "Symptom Duration": "症状持续时间",
        "No weakness (short)": "无肌无力",
      },
      form: {
        diabetes: "0",
        hypertension: "0",
        ageOver60: "0",
        clinic: "",
        duration: "",
        dual: "0",
        stenosis: "0",
        mri: "0",
      },
      dataList1: [
        { value: "1", name: "不伴无力的言语障碍", shortName: "仅言语障碍" },
        { value: "2", name: "单侧肌无力", shortName: "单侧" },
      ],
      dataList2: [
        { value: "1", name: "10 - 59 分钟", shortName: "10 - 59 分钟" },
        { value: "2", name: "60 分钟或更久", shortName: "≥ 60 分钟" },
      ],
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // diabetes + hypertension + ageOver60 + clinic + duration  + (dual ? 2 : 0) + (mri ? 2 : 0) + (stenosis ? 2 : 0)
        let result =
          form.diabetes +
          form.hypertension +
          form.ageOver60 +
          form.clinic +
          form.duration +
          (form.dual ? 2 : 0) +
          (form.mri ? 2 : 0) +
          (form.stenosis ? 2 : 0);

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/ABCD.vue